/**
 * Invite deep-link entry (warcarp.com/invite/<code>) — a THIN redirector.
 *
 * All it does is hand off to the guarded in-app join flow at
 * /(app)/join/<code>, which resolves the code to a game and drops the viewer
 * on the lobby (State B — "join or not"). Crucially, that route lives under the
 * `(app)` group, so the ONE auth guard (app/(app)/_layout) owns everything:
 *   • already signed in  → straight to the lobby.
 *   • signed out         → bounced to login (which persists the target and
 *                          resumes it after auth — including the sign-UP +
 *                          email-confirmation hop). See lib/pendingRedirect.
 *
 * This deliberately has NO sign-in / join UI of its own — a standalone auth
 * screen here is what caused duplicated redirect logic and the "logged-in but
 * shown the login view" bug.
 */

import React, { useEffect, useRef } from 'react'
import { View, ActivityIndicator } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'

export default function InviteRedirect() {
  const { code } = useLocalSearchParams<{ code: string }>()
  const router = useRouter()
  const doneRef = useRef(false)

  useEffect(() => {
    if (doneRef.current || !code) return
    doneRef.current = true
    router.replace(`/(app)/join/${code}` as Parameters<typeof router.replace>[0])
  }, [code, router])

  return (
    <View className="flex-1 bg-canvas items-center justify-center">
      <ActivityIndicator size="large" color="#ef4444" />
    </View>
  )
}
